export default __webpack_public_path__ + "static/media/BranchesAndDeliveryDesktop.bd98f6df.png";